import { IconBaseProps, IconType } from "@/types/icon";

export const GrayCheckCircleIcon: IconType = ({
  size = 24,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 5.25C17.8849 5.25 14.8398 6.17372 12.2498 7.90435C9.6597 9.63498 7.64098 12.0948 6.4489 14.9727C5.25682 17.8507 4.94492 21.0175 5.55264 24.0727C6.16036 27.1279 7.6604 29.9342 9.86307 32.1369C12.0658 34.3396 14.8721 35.8396 17.9273 36.4474C20.9825 37.0551 24.1493 36.7432 27.0273 35.5511C29.9052 34.359 32.365 32.3403 34.0956 29.7502C35.8263 27.1602 36.75 24.1151 36.75 21C36.7454 16.8242 35.0846 12.8208 32.1319 9.86813C29.1792 6.91543 25.1758 5.25459 21 5.25ZM26.8385 18.9635L20.5385 25.2635C20.2432 25.5588 19.8426 25.7247 19.425 25.7247C19.0074 25.7247 18.6068 25.5588 18.3115 25.2635L15.1615 22.1135C14.8746 21.8165 14.7158 21.4186 14.7194 21.0057C14.723 20.5927 14.8886 20.1977 15.1807 19.9057C15.4727 19.6136 15.8677 19.448 16.2807 19.4444C16.6936 19.4408 17.0915 19.5996 17.3885 19.8865L19.425 21.9229L24.6115 16.7365C24.9085 16.4496 25.3064 16.2908 25.7193 16.2944C26.1323 16.298 26.5273 16.4636 26.8193 16.7557C27.1114 17.0477 27.277 17.4427 27.2806 17.8557C27.2842 18.2686 27.1254 18.6665 26.8385 18.9635Z"
        fill="currentColor"
        fillOpacity="0.38"
      />
    </svg>
  );
};
